import * as Sentry from '@sentry/react'
import axios from 'axios'

export const geoLocationByIP = async (): Promise<string | undefined> => {
  try {
    const result = await axios('/api/country')
    const country: string = result?.data?.toUpperCase()

    return country || undefined
  } catch (exception) {
    Sentry.captureException(exception)
  }
}

export const geoQuizCountry = async (countryCookie?: string): Promise<string | undefined> => {
  try {
    if (countryCookie) {
      return countryCookie
    }

    return await geoLocationByIP()
  } catch (exception) {
    Sentry.captureException(exception)
    return undefined
  }
}
